export default __webpack_public_path__ + "static/media/1623.a8477b66.png";